<template>
    <div class="container-fluid mt-3">
        <!-- FILTER -->
        <div class="card mb-3">
            <div class="card-body">
                <div class="row">

                    <div class="col-md-2 mb-2">
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Mã, tên nhân viên"
                            v-model="filters.keyword"
                        >
                    </div>
                    <div class="">

                        <button
                            class="btn btn-primary mr-2"
                            @click="searcha"
                        >
                            Tìm kiếm
                        </button>


                    </div>

                </div>

            </div>
            <!-- TABLE -->
            <div class="p-3">
                <div class="card example-preview table-responsive overflow-auto mt-3">
                    <table class="main-table">
                        <colgroup>
                            <col class="col-name">
                            <col class="col-phone">
                            <col class="col-level">
                            <col class="col-detail">
                        </colgroup>
                        <thead>
                        <tr>
                            <th class="sortable">
                                Nhân sự
                            </th>
                            <th>Số điện thoại</th>
                            <th>Vị trí</th>
                            <th>Chi tiết</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-if="pagedData.length === 0" class="empty-row">
                            <td colspan="5">Không có dữ liệu phù hợp</td>
                        </tr>
                        <template v-for="row in pagedData">
                            <tr>
                                <td>
                                    <div class="name-cell">
                                        <span class="name-text">{{ row.name.trim() }} - {{ row.id + 100000 }}</span>
                                    </div>
                                </td>
                                <td>
                                    <span v-if="row.phone" class="phone-text">{{ row.phone }}</span>
                                    <span v-else class="no-phone">Chưa có</span>
                                </td>
                                <td>
                                    {{ row.profile && row.profile.account_type ? row.profile.account_type.name : '—' }}
                                </td>
                                <td>
                                    <button class="btn btn-sm ml-1 btn-outline-success"
                                            :class="{ active: expanded.includes(row.id) }"
                                            :disabled="row.criterias.length === 0"
                                            @click="toggleExpand(row.id)"
                                            title="Xem chi tiết">
                                        <i class="far fa-eye"></i>
                                    </button>
                                </td>
                            </tr>
                            <tr v-if="expanded.includes(row.id)" class="sub-row">
                                <td colspan="5">
                                    <div class="sub-scroll-wrap">
                                        <table class="sub-table">
                                            <thead>
                                            <tr>
                                                <th class="sticky-left" style="min-width:160px;">Tiêu chí</th>
                                                <th style="min-width:90px;">Nhiệm vụ</th>
                                                <th style="min-width:90px;">Loại chỉ số</th>
                                                <th
                                                    v-for="(lv, lvi) in getRowLevels(row)"
                                                    :class="row.latest_level_approval_request.current_level.id == lv.id ? 'bg-warning' : ''"
                                                    :key="`head-level-${row.id}-${lv.id || lv.level || lvi}`"
                                                >
                                                    Bậc {{ lv.level }}
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="c in row.criterias" :key="c.id">
                                                <td class="criteria-name sticky-left"> <span :title="c.name">{{ truncateText(c.name) }}</span></td>
                                                <td>{{ c.task }}</td>
                                                <td>
                                                     <span :class="c.type === 1 ? 'tag-month' : 'tag-quarter'">
                                                        {{ c.type === 1 ? 'Tháng' : 'Quý' }}
                                                     </span>
                                                </td>
                                                <td v-for="(lv, lvi) in getRowLevels(row)"
                                                    :class="row.latest_level_approval_request.current_level.id == lv.id ? 'bg-warning' : ''"
                                                    :key="`score-cell-${c.id}-${lv.id || lv.level || lvi}`"
                                                    class="score-val">
                                                    {{ getScoreByLevel(c, lv) }}
                                                </td>

                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>
                <div class="pagination-wrap">
                    <paginate v-model="page" :page-count="last_page" :page-range="3" :margin-pages="1"
                              :click-handler="clickCallback"
                              :prev-text="'Trước'" :next-text="'Sau'"
                              :container-class="'pagination b-pagination justify-content-center mt-0 mb-0'"
                              :pageLinkClass="'page-link'"
                              :next-link-class="'next-link-item'"
                              :prev-link-class="'prev-link-item'" :prev-class="'page-link'"
                              :next-class="'page-link'" :page-class="'page-item'">
                    </paginate>
                </div>
            </div>

        </div>
        <el-dialog
            title="Thêm mới level nhân sự"
            :visible.sync="dialogCreate"
            width="70%"
            @close="resetCreateForm"
        >
            <ValidationObserver v-slot="{ handleSubmit }" ref="createFormObserver">
                <form @submit.prevent="handleSubmit(submitCreate)">
                    <div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Mã nhân sự</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="createForm.user_id"
                                        placeholder="Nhập mã nhân sự"
                                    />
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Họ và tên</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="createForm.user_name"
                                        placeholder="Nhập họ và tên"
                                    />
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Chức vụ</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="createForm.account_name"
                                        placeholder="Nhập chức vụ"
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <div class="font-weight-bold">Chỉ số chính</div>
                            <el-button type="primary" size="mini" @click="addCreateItem">
                                + Thêm chỉ số
                            </el-button>
                        </div>

                        <div class="table-responsive">
                            <table class="table table-bordered">
                                <thead>
                                <tr>
                                    <th style="min-width: 260px">Chỉ số chính</th>
                                    <th
                                        v-for="(col, colKey) in headerColumns"
                                        :key="colKey"
                                        style="min-width: 180px"
                                    >
                                        {{ col.name || colKey }}
                                    </th>
                                    <th style="min-width: 90px">Xóa</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-if="createForm.items.length === 0">
                                    <td :colspan="2 + headerColumnKeys.length" class="text-center">
                                        Chưa có chỉ số. Bấm “Thêm chỉ số” để thêm.
                                    </td>
                                </tr>
                                <tr v-for="(row, rowIndex) in createForm.items" :key="rowIndex">
                                    <td>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="row.key_index"
                                            placeholder="Nhập tên chỉ số chính"
                                        />
                                    </td>
                                    <td v-for="colKey in headerColumnKeys" :key="colKey">
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="row[colKey].value"
                                            :placeholder="headerColumns[colKey]?.name || colKey"
                                        />
                                    </td>
                                    <td class="text-center">
                                        <button class="btn btn-outline-danger p-0 mr-2"
                                                title="Xoá" type="button"
                                                @click="removeCreateItem(rowIndex)"><i
                                            class="el-icon-delete p-2"></i>
                                        </button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogCreate = false">Hủy</el-button>
                        <el-button type="primary" native-type="submit">Thêm mới</el-button>
                    </div>
                </form>
            </ValidationObserver>
        </el-dialog>

        <el-dialog
            title="Sửa tiêu chí & điểm chuẩn"
            :visible.sync="dialogEditCriteria"
            width="700px"
            @close="resetEditCriteriaForm"
        >
            <ValidationObserver v-slot="{ handleSubmit }" ref="editCriteriaObserver">
                <form @submit.prevent="handleSubmit(saveEditCriteria)">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Tên tiêu chí<span class="text-danger">*</span></label>
                                <ValidationProvider name="Tên tiêu chí" rules="required" v-slot="{ errors, classes }">
                                    <input
                                        type="text"
                                        class="form-control"
                                        :class="classes"
                                        v-model="editCriteriaForm.name"
                                        placeholder="Nhập tên tiêu chí"
                                    >
                                    <div class="fv-plugins-message-container">
                                        <div class="fv-help-block">
                                            {{ errors[0] }}
                                        </div>
                                    </div>
                                </ValidationProvider>
                            </div>
                        </div>
                    </div>

                    <div class="table-responsive">
                        <table class="table table-bordered mb-0">
                            <thead>
                            <tr>
                                <th style="min-width: 160px">Level</th>
                                <th style="min-width: 180px">Điểm chuẩn<span class="text-danger">*</span></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(lv, idx) in editCriteriaForm.levels" :key="idx">
                                <td>{{ lv.level_label }}</td>
                                <td>
                                    <ValidationProvider :name="`Điểm chuẩn level ${lv.level_label}`" rules="required"
                                                        v-slot="{ errors, classes }">
                                        <input
                                            type="text"
                                            class="form-control"
                                            :class="classes"
                                            v-model="lv.score_standard"
                                        >
                                        <div class="fv-plugins-message-container">
                                            <div class="fv-help-block">
                                                {{ errors[0] }}
                                            </div>
                                        </div>
                                    </ValidationProvider>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <div slot="footer" class="dialog-footer d-flex justify-content-end">
                        <el-button @click="dialogEditCriteria = false">Hủy</el-button>
                        <el-button type="primary" :loading="savingEditCriteria" native-type="submit"
                                   style="background: #4D44B5 !important; color: white !important; padding: 10px 20px; border-radius: 5px">
                            Xác nhận
                        </el-button>
                    </div>
                </form>
            </ValidationObserver>
        </el-dialog>

    </div>
</template>

<script>
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {GET_CRITERIA_STANDARD,} from "@/core/services/store/level/level.module";
import {mapGetters} from "vuex";

export default {
    name: "LevelManagement",
    computed: {
        ...mapGetters(['currentUser']),
        filteredData() {
            let d = this.rawData;
            const q = this.search.trim().toLowerCase();
            if (q) {
                d = d.filter(r =>
                    r.name.toLowerCase().includes(q) ||
                    (r.phone && r.phone.includes(q))
                );
            }
            if (this.filter === 'has') d = d.filter(r => r.criterias.length > 0);
            if (this.filter === 'none') d = d.filter(r => r.criterias.length === 0);
            if (this.sortKey === 'name') {
                d = [...d].sort((a, b) => a.name.localeCompare(b.name, 'vi') * this.sortDir);
            }
            return d;
        },
        totalPages() {
            return Math.max(1, Math.ceil(this.filteredData.length / this.pageSize));
        },
        pagedData() {
            const start = (this.page - 1) * this.pageSize;
            return this.filteredData.slice(start, start + this.pageSize);
        }
    },
    data() {
        return {
            dialogCreate: false,
            dialogImport: false,
            is_export_excel: false,
            fileImport: null,
            dataImport: [],
            createForm: {
                user_id: "",
                user_name: "",
                account_name: "",
                items: []
            },
            filters: {
                keyword: "",
                status: "",
                type: ""
            },
            checkData: true,
            listStatus: [
                {id: 1, value: 'Hoạt động'},
                {id: 0, value: 'Ngừng'},
            ],
            listTypeLevel: [
                {id: 1, value: 'aaa'},
                {id: 0, value: 'vbvvvv'},
            ],
            // Đang sửa bản ghi nào (theo index của reports)
            editingIndex: null,
            editReportForm: null,
            levels: [],
            rawData: [],
            expanded: [],
            sortKey: 'name',
            sortDir: 1,
            page: 1,
            pageSize: 20,
            search: '',
            filter: 'all',
            headerColumns: [],
            headerColumnKeys: [],

            dialogEditCriteria: false,
            savingEditCriteria: false,
            editCriteriaForm: {
                id: null,
                user_id: null,
                name: "",
                levels: [],
            },
            last_page: 1,
            currentLevelId: ''
        }
    },
    mounted() {
        this.getListTeamleadCriteriaStandard();
        this.$store.dispatch(SET_BREADCRUMB, [
            {title: "Quản lý Level", route: "level-employees"},
            {title: "Tiêu chí teamlead"},
        ]);
    },
    methods: {
        clickCallback(obj) {
            this.page = obj
            this.getListTeamleadCriteriaStandard();
        },
        toggleExpand(id) {
            const idx = this.expanded.indexOf(id);
            if (idx === -1) this.expanded.push(id);
            else this.expanded.splice(idx, 1);
        },

        resetEditCriteriaForm() {
            this.editCriteriaForm = {
                id: null,
                user_id: null,
                name: "",
                levels: [],
            };
            this.savingEditCriteria = false;
        },
        getRowLevels(row) {
            const map = new Map();
            (row?.criterias || []).forEach((c) => {
                (c?.score_standards || []).forEach((s) => {
                    const level = s?.level;
                    if (!level) return;
                    const key = level.id ?? level.level;
                    if (!map.has(key)) {
                        map.set(key, {
                            id: level.id ?? null,
                            level: level.level ?? "",
                            name: level.name ?? "",
                        });
                    }
                });
            });
            return Array.from(map.values()).sort((a, b) => Number(a.level) - Number(b.level));
        },
        getScoreByLevel(criteria, level) {
            const found = (criteria?.score_standards || []).find(
                (s) => (s?.level?.id ?? s?.level?.level) === (level?.id ?? level?.level)
            );
            if (!found) return "—";
            const score = found?.score_standard;
            return score === null || score === undefined || score === "" ? "—" : `${score} %`;
        },
        saveEditCriteria() {
            this.savingEditCriteria = true;
            const isCreate = !this.editCriteriaForm?.id;
            const payload = {
                name: this.editCriteriaForm.name,
                user_id: this.editCriteriaForm.user_id,
                levels: (this.editCriteriaForm.levels || []).map((lv) => ({
                    id: lv.id,
                    score_standard: lv.score_standard,
                })),
            };
            if (!isCreate) {
                payload.id = this.editCriteriaForm.id;
            }

            const action = isCreate ? CREATE_TEAMLEAD_CRITERIA_STANDARD : UPDATE_TEAMLEAD_CRITERIA_STANDARD;

            this.$store
                .dispatch(action, payload)
                .then(() => {
                    this.$bvToast?.toast?.("Cập nhật thành công", {
                        title: "Sửa",
                        variant: "success",
                        solid: true,
                    });
                    this.dialogEditCriteria = false;
                    this.getListTeamleadCriteriaStandard();
                })
                .catch((err) => {
                    this.$bvToast?.toast?.(err?.data?.message || "Có lỗi xảy ra", {
                        title: "Sửa",
                        variant: "danger",
                        solid: true,
                    });
                })
                .finally(() => {
                    this.savingEditCriteria = false;
                });
        },
        getListTeamleadCriteriaStandard() {
            this.$store
                .dispatch(GET_CRITERIA_STANDARD, this.filters)
                .then((res) => {
                    this.rawData = res.data.data;
                    this.last_page = res.data.last_page;
                    this.$bvToast?.toast?.("Thêm mới thành công", {
                        title: "Thêm mới",
                        variant: "success",
                        solid: true,
                    });
                    const current = this.rawData.find(item => item.id == this.currentUser.id);

                    this.currentLevelId = current && current.latest_level_approval_request && current.latest_level_approval_request.current_level ?
                        current.latest_level_approval_request.current_level.id :
                        '';

                    console.log(this.currentLevelId, 'aaaa')

                })
                .catch((e) => {
                    console.log(e);
                })
                .finally(() => {
                    this.savingCreate = false;
                });
            console.log(this.reports, 'this.header')
        },
        searcha() {
            this.getListTeamleadCriteriaStandard();
        },

        resetCreateForm() {
            this.createForm = {
                user_id: "",
                user_name: "",
                account_name: "",
                items: []
            };
        },

        addCreateItem() {
            const row = {key_index: ""};
            this.headerColumnKeys.forEach((key) => {
                row[key] = {
                    id: this.headerColumns[key]?.id ?? 1,
                    name: this.headerColumns[key]?.name ?? key,
                    value: ""
                };
            });
            this.createForm.items.push(row);
        },

        removeCreateItem(rowIndex) {
            this.createForm.items.splice(rowIndex, 1);
        },

        submitCreate() {
            const newReport = JSON.parse(JSON.stringify(this.createForm));
            this.dialogCreate = false;
            this.resetCreateForm();
        },
        truncateText(text, maxLength = 40) {
            if (!text) return '';
            return text.length > maxLength
                ? text.slice(0, maxLength) + '...'
                : text;
        }

    }

}
</script>
<style>
*, *::before, *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

body {
    font-family: 'Segoe UI', sans-serif;
    background: #f4f6fb;
    color: #222;
}

/* ===== CARD ===== */
.card {
    background: #fff;
    border-radius: 12px;
    border: 1px solid #e5e7eb;
    overflow: hidden;
}

/* ===== OUTER TABLE ===== */
.outer-table-wrap {
    overflow-x: auto;
}

table.main-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
}

table.main-table col.col-name {
    width: 28%;
}

table.main-table col.col-phone {
    width: 18%;
}

table.main-table col.col-level {
    width: 30%;
}

table.main-table col.col-detail {
    width: 24%;
}

table.main-table thead th {
    background: #f9fafb;
    padding: 11px 14px;
    font-weight: 600;
    color: #6b7280;
    border-bottom: 1px solid #e5e7eb;
    white-space: nowrap;
    text-align: left;
}

table.main-table thead th.sortable {
    cursor: pointer;
    user-select: none;
}

table.main-table thead th.sortable:hover {
    color: #374151;
}

table.main-table tbody td {
    padding: 11px 14px;
    border-bottom: 1px solid #f0f0f0;
    vertical-align: middle;
    overflow: hidden;
    text-overflow: ellipsis;
}

table.main-table tbody tr:last-child td {
    border-bottom: none;
}

table.main-table tbody tr:not(.sub-row):hover {
    background: #fafafa;
}


.name-cell {
    display: flex;
    align-items: center;
}

.name-text {
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.phone-text {
    color: #6b7280;
    font-size: 13px;
}

.no-phone {
    color: #9ca3af;
    font-style: italic;
}

/* ===== BADGES ===== */
.badge {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 99px;
}

.badge-purple {
    background: #ede9fe;
    color: #5b21b6;
}

.badge-blue {
    background: #dbeafe;
    color: #1d4ed8;
}

.badge-green {
    background: #dcfce7;
    color: #15803d;
}

.badge-amber {
    background: #fef9c3;
    color: #92400e;
}

/* ===== BUTTONS ===== */

.sub-row > td {
    padding: 0 !important;
    background: #f8faff;
}

/*
  overflow-x: auto tạo scroll context riêng biệt.
  Scroll này KHÔNG lan ra ngoài table cha.
*/
.sub-scroll-wrap {
    overflow-x: auto;
    width: 100%;
    -webkit-overflow-scrolling: touch;
    border-top: 2px solid #818cf8;
    border-bottom: 1px solid #e5e7eb;
}

/* Scrollbar đẹp hơn */
.sub-scroll-wrap::-webkit-scrollbar {
    height: 6px;
}

.sub-scroll-wrap::-webkit-scrollbar-track {
    background: #f1f1f1;
}

.sub-scroll-wrap::-webkit-scrollbar-thumb {
    background: #c7d2fe;
    border-radius: 99px;
}

.sub-scroll-wrap::-webkit-scrollbar-thumb:hover {
    background: #818cf8;
}

table.sub-table {
    border-collapse: collapse;
    /*
      KHÔNG set width: 100% ở đây.
      Để table tự rộng theo nội dung (max-content).
      Kết hợp với white-space: nowrap bên dưới → tạo ra nội dung
      rộng hơn container → overflow-x: auto của wrap hoạt động.
    */
    white-space: nowrap;
}

table.sub-table th {
    padding: 9px 14px;
    font-size: 12px;
    font-weight: 600;
    color: #6b7280;
    background: #f0f4ff;
    border: 1px solid #e5e7eb;
    white-space: nowrap;
}

table.sub-table td {
    padding: 9px 14px;
    border: 1px solid #f0f0f0;
    background: #fff;
}

table.sub-table tbody tr:hover td {
    background: #f9f9ff;
}

.score-val {
    font-weight: 600;
}

.criteria-name {
    font-weight: 600;
    color: #1d4ed8;
}

.tag-month {
    background: #dcfce7;
    color: #166534;
    padding: 2px 8px;
    border-radius: 99px;
    font-size: 11px;
}

.tag-quarter {
    background: #fef9c3;
    color: #92400e;
    padding: 2px 8px;
    border-radius: 99px;
    font-size: 11px;
}

/* ===== STICKY COLUMNS trong sub-table ===== */
.sticky-left {
    position: sticky;
    left: 0;
    z-index: 3;
}

table.sub-table th.sticky-left {
    background: #e8eeff;
    border-right: 2px solid #c7d2fe !important;
}

table.sub-table td.sticky-left {
    background: #f4f6ff;
    border-right: 2px solid #c7d2fe !important;
}

.sticky-right {
    position: sticky;
    right: 0;
    z-index: 3;
}

table.sub-table th.sticky-right {
    background: #e8eeff;
    border-left: 2px solid #c7d2fe !important;
}

table.sub-table td.sticky-right {
    background: #f4f6ff;
    border-left: 2px solid #c7d2fe !important;
}

.action-row {
    display: flex;
    gap: 6px;
    align-items: center;
}

/* ===== PAGINATION ===== */
.pagination-wrap {
    display: flex;
    justify-content: center;
    gap: 4px;
    padding: 16px;
    border-top: 1px solid #f0f0f0;
}

.page-btn {
    padding: 5px 12px;
    border-radius: 7px;
    border: 1px solid #e5e7eb;
    background: transparent;
    cursor: pointer;
    color: #374151;
}

.page-btn:hover {
    background: #f3f4f6;
}

.page-btn.active {
    background: #6d28d9;
    color: #fff;
    border-color: #6d28d9;
}

.page-btn:disabled {
    opacity: 0.4;
    cursor: not-allowed;
}

/* ===== EMPTY ===== */
.empty-row td {
    text-align: center;
    color: #9ca3af;
    padding: 40px 0;
    font-style: italic;
}
</style>